import { render, staticRenderFns } from "./ReporteEntregas.vue?vue&type=template&id=2dea420b&"
import script from "./ReporteEntregas.vue?vue&type=script&lang=js&"
export * from "./ReporteEntregas.vue?vue&type=script&lang=js&"
import style0 from "./ReporteEntregas.vue?vue&type=style&index=0&id=2dea420b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports